const getPermissionFromObject = (obj, permission) => {
  if (!obj || typeof obj !== 'object') return false;
  if (obj['*'] === true) return true;

  const parts = String(permission || '').split('.').filter(Boolean);
  let cursor = obj;
  for (const part of parts) {
    if (!cursor || typeof cursor !== 'object') return false;
    cursor = cursor[part];
  }
  return cursor === true;
};

const normalizePermissionName = (permission) => {
  const value = String(permission || '').trim();
  if (!value) return value;
  if (value === 'manage_employees') return 'manage_all_employees';
  return value;
};

const hasPermission = (user, permission) => {
  const grants =
    user?.employee?.permission_grants && typeof user.employee.permission_grants === 'object' && !Array.isArray(user.employee.permission_grants)
      ? user.employee.permission_grants
      : {};
  return getPermissionFromObject(grants, normalizePermissionName(permission));
};

export const isAdmin = (user) => {
  return hasPermission(user, '*');
};

export const isApprover = (user) => {
  return hasPermission(user, 'approve_time_off');
};

export const canApproveTimeOff = (user) => {
  return hasPermission(user, 'approve_time_off');
};

export const canApproveExpenses = (user) => {
  return hasPermission(user, 'approve_expenses');
};

export const canEditField = (user, fieldName) => {
  if (isAdmin(user)) return true;
  const editable = new Set([
    'phone',
    'office_phone',
    'office_phone_extension',
    'address',
    'preferences',
    'job_title',
    'birthday',
    'share_birthday_during_meetings',
     'emergency_contact_name',
     'emergency_contact_phone',
     'emergency_contact_relationship'
  ]);
  return editable.has(fieldName);
};

export const canViewField = (user, fieldName) => {
  if (isAdmin(user)) return true;
  // Employees can view all fields on their own profile.
  // (Access control for viewing other employees is enforced by routes.)
  return true;
};
